import {Space} from "antd";
import {SessionCheckoutFormFieldsProps} from "./types";
import {SessionCheckoutFormGroups} from "../../../accordion/data";
import {OfferingFormAccordionItem} from "../../../accordion/accordion-item";

export function SessionCheckoutFormFields({
  isBookingQuestionsError,
}: SessionCheckoutFormFieldsProps) {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {SessionCheckoutFormGroups.map((fg, index) => {
        if (fg.title === "Checkout form") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isBookingQuestionsError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else {
          return null;
        }
      })}
    </Space>
  );
}
